import {cn} from '@/utils';
import React, {FC} from 'react';

export interface CheckBoxSvgProps {
  className?: string;
  visible?: boolean;
}

const CheckBoxSvg: FC<CheckBoxSvgProps> = ({className, visible}) => {
  return (
    <svg
      viewBox="0 0 20 20"
      className={cn('text-c1 size-5', className)}
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <rect x="0.5" y="0.5" width="19" height="19" rx="3.5" fill="#EFF1F7" />
      <rect
        x="0.5"
        y="0.5"
        width="19"
        height="19"
        rx="3.5"
        stroke="currentColor"
      />
      {visible && (
        <path d="M5 10L8.5 13.5L15 7" stroke="currentColor" strokeWidth="2" />
      )}
    </svg>
  );
};

export default CheckBoxSvg;
